export enum MediaCreditType {
  KeyCredit = 'KeyCredit',
  CloudCredit = 'CloudCredit',
}
